import React, { useCallback, useMemo } from 'react';
import bem from 'utils/bem.js';
import { Popover } from '@mui/material';
import { useRequestPermission } from '../../utils/hooks/useRequestPermission';

const { cnBlock, el } = bem('request-permission-popover');
export const RequestPermissionPopover = ({ className, room, permissionName, isMuted, toggleMute, children }) => {
    const { isActiveRequestPermission, isSent, timeValue, requestPermission } =
        useRequestPermission({ permissionName, room, isMuted })

    const [ anchorEl, setAnchorEl ] = React.useState<HTMLDivElement | null>(null);

    const handlePopoverOpen = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        event.preventDefault();
        isActiveRequestPermission && setAnchorEl(event.currentTarget);
    }, [isActiveRequestPermission, setAnchorEl]);

    const handlePopoverClose = useCallback((event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(null);
    }, [setAnchorEl]);

    const open = useMemo(() => Boolean(anchorEl), [anchorEl]);

    return (
        <div className={cnBlock(className)} onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose} onClick={toggleMute}>
            <div className={el('button-container')} >
                { children }
            </div>
            <Popover
                slotProps={{ root: { style: { pointerEvents: 'none' } }}}
                disablePortal={ true }
                open={ open }
                onClose={ handlePopoverClose }
                anchorEl={ anchorEl }
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <button
                    aria-label={`Request permission ${permissionName}`}
                    title={`Request permission ${permissionName}`}
                    disabled={ isSent }
                    style={ { pointerEvents: 'auto' } }
                    onClick={ requestPermission }>
                    {
                        isSent
                            ? `Retry request after: ${ timeValue }`
                            : 'Request permission'
                    }
                </button>
            </Popover>
        </div>
    );
};
